import { BarChart3, FileSearch, Presentation, Shuffle, TrendingDown } from 'lucide-react';

export interface PlaybookSuggestionsProps {
  onSelect: (text: string) => void;
  className?: string;
}

const PLAYBOOK_SUGGESTIONS = [
  {
    icon: Presentation,
    text: 'Prepare a quarterly business review deck for my top 10 merchants',
  },
  {
    icon: BarChart3,
    text: "Break down my portfolio's approval rates by processor and card brand",
  },
  {
    icon: TrendingDown,
    text: 'Find merchants whose processing volume dropped more than 20% this month',
  },
  {
    icon: FileSearch,
    text: "Pull a report for yesterday's decline codes",
  },
];

export function PlaybookSuggestions({ onSelect, className }: PlaybookSuggestionsProps) {
  return (
    <div className={className}>
      <div className="sd-reveal-4 flex items-center gap-sd-2 mb-sd-3 px-sd-1">
        <Shuffle size={14} className="text-sd-warning" />
        <span className="text-sd-xs font-semibold text-sd-text-muted uppercase tracking-wider">
          Pick a playbook to start
        </span>
      </div>
      <div className="grid grid-cols-1 @md:grid-cols-2 gap-sd-2">
        {PLAYBOOK_SUGGESTIONS.map((s, i) => (
          <button
            key={s.text}
            type="button"
            data-testid={`suggestion-${i}`}
            className={`sd-reveal-${i + 5} flex items-start gap-sd-2 px-sd-3 py-sd-3 rounded-sd-lg bg-sd-surface/80 border border-sd-border/30 text-left text-sd-sm text-sd-text-secondary hover:border-sd-warning/40 hover:bg-sd-surface hover:text-sd-text hover:shadow-sd-sm active:scale-[0.98] transition-all duration-200 cursor-pointer`}
            onClick={() => onSelect(s.text)}
          >
            <s.icon size={16} className="shrink-0 mt-[2px] text-sd-warning" />
            <span className="line-clamp-2 leading-snug">{s.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
